var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmenuopen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 0L0 3.75L10 13.75L20 3.75L16.25 0L10 6.25L3.75 0Z",
    fill: "#C367CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmenuopen);
export default __webpack_public_path__ + "static/media/iconmenuopen.29d4f62af080a5941f77f30ecf0493a9.svg";
export { ForwardRef as ReactComponent };